import React from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, Building2 } from "lucide-react";
import { API } from "../../lib/api";
import axios from "axios";

export default function BusinessLoginPage() {
  const nav = useNavigate();
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [busy, setBusy] = React.useState(false);

  React.useEffect(() => {
    if (localStorage.getItem("ema_business_token")) nav("/business/dashboard", { replace: true });
  }, [nav]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/business/auth/login`, { email, password });
      localStorage.setItem("ema_business_token", data.token);
      localStorage.setItem("ema_business_customer", JSON.stringify(data.customer));
      localStorage.setItem("ema_business_user", JSON.stringify(data.user));
      toast.success(`Velkommen, ${data.customer?.company_name}`);
      if (data.user?.must_change_password) nav("/business/change-password", { replace: true });
      else nav("/business/dashboard", { replace: true });
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Login fejlede");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-brand-bg2 flex items-center justify-center px-4" data-testid="business-login-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-6">
          <div className="inline-flex items-center gap-2 text-brand-dark mb-2">
            <Building2 size={28}/>
            <span className="font-display font-bold text-2xl">EMA Business Portal</span>
          </div>
          <p className="text-sm text-brand-text2">Log ind for at administrere dine forsendelser</p>
        </div>
        <form onSubmit={onSubmit} className="bg-white border border-brand p-6 space-y-4">
          <div>
            <label className="label-flat">Email</label>
            <input className="input-flat" type="email" autoFocus required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="business-login-email"/>
          </div>
          <div>
            <label className="label-flat">Kodeord</label>
            <input className="input-flat" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="business-login-password"/>
          </div>
          <button type="submit" disabled={busy} className="btn-primary w-full justify-center" data-testid="business-login-submit">
            {busy ? <Loader2 className="animate-spin" size={16}/> : "Log ind"}
          </button>
          <div className="text-center text-sm">
            <Link to="/business/forgot-password" className="text-brand-red underline" data-testid="business-forgot-link">Glemt kodeord?</Link>
          </div>
        </form>
        <p className="text-xs text-brand-text2 text-center mt-6">
          Har du ikke en konto? Kontakt EMA Kurer på <a href="mailto:kontakt@emakurer.dk" className="underline">kontakt@emakurer.dk</a>
        </p>
      </div>
    </div>
  );
}
